// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","white":"Button_white__QBg8M","primary":"Button_primary__XYgy-","primaryDarkBlue":"Button_primaryDarkBlue__KX+fZ","icon":"Button_icon__KeIH3"};